// extracted by mini-css-extract-plugin
module.exports = {"wraps":"ViewResult_wraps__2fJCA","header":"ViewResult_header__3oxCU","tableContainer":"ViewResult_tableContainer__3tZRS"};